<template>
  <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.09066 6.16673L10.399 6.16673L6.33232 2.10007C6.00732 1.77507 6.00732 1.24173 6.33232 0.916732C6.65732 0.591732 7.18232 0.591732 7.50732 0.916732L12.999 6.4084C13.324 6.7334 13.324 7.2584 12.999 7.5834L7.51566 13.0834C7.19066 13.4084 6.66566 13.4084 6.34066 13.0834C6.01566 12.7584 6.01566 12.2334 6.34066 11.9084L10.399 7.8334L1.09066 7.8334C0.632324 7.8334 0.257324 7.4584 0.257324 7.00006C0.257324 6.54173 0.632324 6.16673 1.09066 6.16673Z"/>
  </svg>
</template>
<script setup lang="ts">
</script>